import dotenv from 'dotenv';
dotenv.config();

export const API_END_POINT = process.env.REACT_APP_API_END_POINT;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
